/**
 * Validates that a redirect URL is same-origin and safe to navigate to.
 * Prevents open redirect attacks (CWE-601).
 *
 * Security rules:
 * 1. Must be relative path (starts with /)
 * 2. Cannot be protocol-relative (//)
 * 3. Cannot start with backslash (/\) - browser normalization bypass
 * 4. Cannot be absolute URL (https://, http://, etc.)
 *
 * @param url - The URL to validate (may be relative or absolute)
 * @returns Validated URL if safe, '/' otherwise
 */
export function validateRedirectUrl(url: string | null | undefined): string {
  // Handle null, undefined, or empty string
  if (!url || !url.trim()) {
    return '/';
  }

  const trimmedUrl = url.trim();

  // Security: Validate redirect is same-origin
  // Must start with / but NOT // (protocol-relative) or /\ (backslash bypass)
  const isSafeRedirect =
    trimmedUrl.startsWith('/') &&
    !trimmedUrl.startsWith('//') &&
    !trimmedUrl.startsWith('/\\');

  return isSafeRedirect ? trimmedUrl : '/';
}
